module.exports = __webpack_public_path__ + "assets/304339b85b402667edbc1010578067ea.jpg";